export default __webpack_public_path__ + "static/media/favorite-person.1ff9d699.webp";